import _slicedToArray from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from 'react';
import { useLanguageCode } from './TranslationContext';
import { Helmet } from 'react-helmet';
export var HelmetTranslationProvider = function HelmetTranslationProvider(_ref) {
  var children = _ref.children;

  var _useLanguageCode = useLanguageCode(),
      _useLanguageCode2 = _slicedToArray(_useLanguageCode, 1),
      languageCode = _useLanguageCode2[0];

  if (languageCode) return React.createElement(React.Fragment, null, React.createElement(Helmet, null, React.createElement("html", {
    lang: languageCode
  }), React.createElement("link", {
    rel: "canonical",
    href: window.location.origin + window.location.pathname
  })), children);else return null;
};